// extracted by mini-css-extract-plugin
export default {"root":"KvtL8Caj","topBanner":"vm5hmsg1","sideBanner":"_8awI0lx9","isLeft":"X1gFuJZ9","isRight":"Yqi4-Akr"};